// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
/**
 * URL-hash routing. The room id and passphrase live ONLY in the hash fragment,
 * which browsers never send to a server — so a shared link carries the whole
 * invite without any of it touching the network.
 */
import { parseInvite, buildInviteUrl } from './room.ts';
import type { Invite } from './types.ts';

export function readInvite(): Invite | null {
  return parseInvite(location.hash);
}

/** Reflect the current room into the address bar (without adding history entries). */
export function writeRoomHash(room: string, pass: string, includePass = true): void {
  const url = buildInviteUrl(location.href, room, pass, includePass);
  const hash = url.slice(url.indexOf('#'));
  history.replaceState(null, '', hash);
}

export function clearHash(): void {
  history.replaceState(null, '', location.pathname + location.search);
}

export function currentInviteUrl(room: string, pass: string, includePass = true): string {
  return buildInviteUrl(location.href, room, pass, includePass);
}
